module.exports = __webpack_public_path__ + "media/images/small_stars-2ad60cc7ca59bb16e7430cf28e14dafc.svg";